import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import api, { baseURL } from "../../utils/api";
import { useFormik } from "formik";
import * as Yup from "yup";
import axios from "axios";

const VerifyCode = ({ OnActiveIndex, email }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const [isLoading, setIsLoading] = useState(false);

  const validationSchema = Yup.object().shape({
    hiddenCode: Yup.string()
      .min(6, "Sign Up Code must be at least 6 characters")
      .required("Sign Up Code is required"),
    // You can add a validation for hiddenPassword if needed.
  });

  const handleSubmit = (values, { setSubmitting }) => {
    setIsLoading(true);
    console.log("emailverifyData", values);
    const { hiddenCode, hiddenPassword, email } = values;
    // OnActiveIndex(2)
    setSubmitting(false);
    axios
      .post(`${baseURL}/user/resetPassword`, {
        email,
        verification: hiddenCode,
        password: hiddenPassword,
      })
      .then((res) => {
        if (res.status === 200) {
          setIsLoading(false);
          setSubmitting(false);
          toast.success("Password reset");
          navigate("/");
        }
      })
      .catch((err) => {
        console.log("err", err);
        setIsLoading(false);
        setSubmitting(false);
        toast.error(err?.response?.data?.error);
      });
  };

  const formik = useFormik({
    initialValues: {
      hiddenCode: "",
      email: email,
      hiddenPassword: "",
    },
    validationSchema,
    onSubmit: handleSubmit,
  });

  const [show, setShow] = useState(false);

  const handleToggle = () => {
    setShow(!show);
  };

  return (
    <form onSubmit={formik.handleSubmit}>
      <div className="form mt-5">
        <div className="relative mt-4">
          <span className="absolute inset-y-0 left-0 pl-3 flex items-center">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
              className="w-7 h-7 text-white"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M3.75 4.875c0-.621.504-1.125 1.125-1.125h4.5c.621 0 1.125.504 1.125 1.125v4.5c0 .621-.504 1.125-1.125 1.125h-4.5A1.125 1.125 0 013.75 9.375v-4.5zM3.75 14.625c0-.621.504-1.125 1.125-1.125h4.5c.621 0 1.125.504 1.125 1.125v4.5c0 .621-.504 1.125-1.125 1.125h-4.5a1.125 1.125 0 01-1.125-1.125v-4.5zM13.5 4.875c0-.621.504-1.125 1.125-1.125h4.5c.621 0 1.125.504 1.125 1.125v4.5c0 .621-.504 1.125-1.125 1.125h-4.5A1.125 1.125 0 0113.5 9.375v-4.5z"
              />
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M6.75 6.75h.75v.75h-.75v-.75zM6.75 16.5h.75v.75h-.75v-.75zM16.5 6.75h.75v.75h-.75v-.75zM13.5 13.5h.75v.75h-.75v-.75zM13.5 19.5h.75v.75h-.75v-.75zM19.5 13.5h.75v.75h-.75v-.75zM19.5 19.5h.75v.75h-.75v-.75zM16.5 16.5h.75v.75h-.75v-.75z"
              />
            </svg>
          </span>
          <input
            className="pl-12 w-full pr-3 py-2 bg-[#2A2E45] h-[56px] rounded border border-gray-300 focus:outline-none"
            type="text"
            placeholder="Code"
            autoComplete="off"
            name="hiddenCode"
            value={formik.values.hiddenCode}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
          />
        </div>
        {formik.touched.hiddenCode && formik.errors.hiddenCode && (
          <div className="text-red-500 mt-1 text-[12px]">
            {formik.errors.hiddenCode}
          </div>
        )}
        <div className="relative mt-5">
          <span className="absolute inset-y-0 left-0 pl-3 flex items-center">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
              className="w-7 h-7 text-white"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M16.5 10.5V6.75a4.5 4.5 0 10-9 0v3.75m-.75 11.25h10.5a2.25 2.25 0 002.25-2.25v-6.75a2.25 2.25 0 00-2.25-2.25H6.75a2.25 2.25 0 00-2.25 2.25v6.75a2.25 2.25 0 002.25 2.25z"
              />
            </svg>
          </span>
          <input
            className="pl-12 w-full pr-3 py-2 bg-[#2A2E45] h-[56px] rounded border border-gray-300 focus:outline-none"
            type={show ? "text" : "password"}
            placeholder="Enter New Password"
            autoComplete="new-password"
            autoCorrect="off"
            autoCapitalize="off"
            name="hiddenPassword"
            value={formik.values.hiddenPassword}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
          />
          {show ? (
            <svg
              onClick={handleToggle}
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth="1.5"
              stroke="currentColor"
              className="w-4 h-4 absolute right-3 top-5 cursor-pointer"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M2.036 12.322a1.012 1.012 0 010-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178z"
              />
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
              />
            </svg>
          ) : (
            <svg
              onClick={handleToggle}
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth="1.5"
              stroke="currentColor"
              className="w-4 h-4 absolute right-3 top-5 cursor-pointer"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M3.98 8.223A10.477 10.477 0 001.934 12C3.226 16.338 7.244 19.5 12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.45 10.45 0 0112 4.5c4.756 0 8.773 3.162 10.065 7.498a10.523 10.523 0 01-4.293 5.774M6.228 6.228L3 3m3.228 3.228l3.65 3.65m7.894 7.894L21 21m-3.228-3.228l-3.65-3.65m0 0a3 3 0 10-4.243-4.243m4.242 4.242L9.88 9.88"
              />
            </svg>
          )}
        </div>
      </div>

      <div>
        <button
          type="submit"
          disabled={formik.isSubmitting}
          className="register-button"
        >
          {isLoading ? (
            <div role="status" className="mx-auto w-[30px]">
              <svg
                aria-hidden="true"
                className="w-8 h-8 mr-2 text-gray-200 animate-spin dark:text-gray-600 fill-[#E4A61A]"
                viewBox="0 0 100 101"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                  fill="currentColor"
                />
                <path
                  d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                  fill="currentFill"
                />
              </svg>
            </div>
          ) : (
            <span> Reset Password Now</span>
          )}
        </button>
      </div>
    </form>
  );
};

export default VerifyCode;
